module.exports = __webpack_public_path__ + "static/media/pathfinder.67aa2ccb.gif";